module.exports = __webpack_public_path__ + "static/media/mobile-app-info-modal.92a699df.png";